import IFindAllFrotistaRequest from '../entities/FindAllFrotistaRequest'
import IFindAllFrotistaResponse from '../entities/FindAllFrotistaResponse'
import { IUserRepository } from '../repositories/IUserRepository'

export interface IListFrotista {
  execute(data: IFindAllFrotistaRequest): Promise<IFindAllFrotistaResponse>
}

export class ListFrotista implements IListFrotista {
  constructor(private readonly userRepository: IUserRepository) {}
  public async execute(
    data: IFindAllFrotistaRequest,
  ): Promise<IFindAllFrotistaResponse> {
    return this.userRepository.findAllFrotistas(data)
  }
}
